import $ from 'jquery';

const $main = $('#nav ul.main');

function openPanel($li) {
    $main.find('li.parent.open').not($li).removeClass('open');
    $li.addClass('open');
    $main.addClass('panel-open');
}

// Parent row: prevent navigation, open submenu on mobile
$(document).on('click', '.main > li.parent > .nav-item-row', function (e) {
    e.preventDefault();
    if (window.innerWidth < 1200) {
        openPanel($(this).closest('li.parent'));
    }
});

// Prevent nav-toggle from double-firing (it bubbles to the row handler above)
$(document).on('click', '.nav-toggle', function (e) {
    e.stopPropagation();
    if (window.innerWidth < 1200) {
        e.preventDefault();
        openPanel($(this).closest('li.parent'));
    }
});

// Mobile only: back button
$(document).on('click', '.back-btn', function () {
    $main.find('li.parent.open').removeClass('open');
    $main.removeClass('panel-open');
});

// Helveron one-pager: mark the menu item whose anchor section is in view
if (document.documentElement.classList.contains('site-helveron')) {
    const spyItems = [];

    $main.children('li').each(function () {
        const href = $(this).children('.nav-item-row').children('a').attr('href') || '';
        const hash = href.includes('#') ? href.slice(href.indexOf('#') + 1) : '';
        const anchor = hash ? document.getElementById(hash) : null;
        const section = anchor ? anchor.closest('section') || anchor : null;

        if (section) {
            spyItems.push({ $li: $(this), section });
        }
    });

    let ticking = false;

    function updateCurrent() {
        ticking = false;
        const line = window.innerHeight * 0.4;
        const atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        let current = null;

        spyItems.forEach(item => {
            if (item.section.getBoundingClientRect().top <= line) {
                current = item;
            }
        });

        if (atBottom && spyItems.length) {
            current = spyItems[spyItems.length - 1];
        }

        spyItems.forEach(item => item.$li.toggleClass('is-current', item === current));
    }

    if (spyItems.length) {
        $(window).on('scroll resize', () => {
            if (!ticking) {
                ticking = true;
                requestAnimationFrame(updateCurrent);
            }
        });
        updateCurrent();
    }
}

// Reset submenus when nav closes
$(document).on('click', '.hamburger', function () {
    setTimeout(() => {
        $main.find('li.parent.open').removeClass('open');
        $main.removeClass('panel-open');
    }, 350);
});
